
import PopupBonusReg from "components/PopupBonusReg";
import PopupLayout from "components/PopupLayout";
import PropTypes from "prop-types";
import React, { useState } from "react";
import './style.scss';

const LabelBonusCoupon = ( {couponHabilitado = null,couponBonus= null} ) => {
const [showBonus, setShowBonus] = useState(false);   
const openBonus = (event, forceValue = 'none') => {
    
    if(couponHabilitado==false){
        event.preventDefault();
        setShowBonus(forceValue === 'none' ? !showBonus : (forceValue));

    }
   
    
}



    return (
        <>
        {couponBonus &&
            <div className={"coupon-bonus "+(couponHabilitado == false ? " coupon-habilitado": "")+" box"}  onClick={openBonus} />
            
        }

        {
        <PopupLayout isShowwing={showBonus} showingCallback={openBonus}>
            <PopupBonusReg execActionConfirm={openBonus} />
        </PopupLayout>
        }
        
        </>
    );
   
};
LabelBonusCoupon.propTypes = {
    couponBonus: PropTypes.bool,
    couponHabilitado: PropTypes.bool
};

export default LabelBonusCoupon;
